import React from 'react';

import './FilterBar.scss';
import Util from '../../../../../../../src/js/Util';

export class FilterBar extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    render() {
        return <div className="algolia-filter-bar">
            <div className="container">
                <div className="filter-bar-header">
                    {Util.translate('Filter by')}
                </div>

                <div className="filter-bar-buttons">
                    { this.props.filters.filter(function(filter) {
                        if(filter.attribute === 'post_status' || filter.attribute === '_exclude_from_search') {
                            return false;
                        }
                        return true;
                    }).map( ( f, i ) => (

                        <button className={`filter-button${f.attribute === this.props.activeFilter ? ' active' : ''}`} key={i} onClick={() => { this.props.toggleFilter(f.attribute) }}>
                            {f.title}
                        </button>
                    ) ) }
                </div>

                <div className="filter-bar-toggle">
                    <button className="filter-bar-toggle-button" onClick={() => { this.props.toggleFilterModal() }}>
                        <i className="fa-light fa-xmark"></i>
                    </button>
                </div>
            </div>
        </div>;
    }
}
